import * as React from 'react'
import classNames from 'classnames'

import { Text, TextName } from 'sdk/text/Text'

import { PaletteColors } from 'core/interfaces'

import classes from './style.module.scss'

type PillVariant = 'outline' | 'outlineMuted' | 'filled' | 'gradient' | 'gradientFilled'
type PillSize = 'sm' | 'md'

interface ComponentProps {
  text?: string
  icon?: string
  variant?: PillVariant
  background?: PaletteColors
  size?: PillSize
  className?: string
  children?: React.ReactNode
}

export const Pill: React.FC<ComponentProps> = ({
  text,
  icon,
  variant = 'outline',
  background,
  size = 'md',
  className,
  children,
}) => {
  const pillClassName = classNames(
    classes.pill,
    classes[variant],
    classes[size],
    {
      [classes[`bg-${background}`]]: variant === 'filled' && background,
      [classes.withIcon]: icon,
    },
    className,
  )

  let textColor
  if (variant === 'filled' && background) {
    textColor = background === 'white' ? classes.blackText : classes.whiteText
  }

  return (
    <div className={pillClassName}>
      {icon && (
        <div className={classes.iconContainer}>
          <img src={icon} alt='' />
        </div>
      )}
      {children ? (
        children
      ) : (
        <Text type={TextName.Subtext} className={classNames(classes.text, textColor)}>
          {text}
        </Text>
      )}
    </div>
  )
}
